import GridActionOnChange from './js/GridActionOnChange';

export default GridActionOnChange;
